import CollectionSplashHeroListItem from './CollectionSplashHeroListItem';
export * from './CollectionSplashHeroListItem';
export default CollectionSplashHeroListItem;
